/**
 * Static region-to-store mapping data
 *
 * Maps Vietnamese region codes to Magento store codes.
 * Mirrors mobile's module-core/src/static/regions-stores.ts
 */

export interface RegionStoreMapping {
    region_id: number;
    region_name: string;
    store_code: string;
    scope: string;
    sort_order: number;
    region_code: string;
}

export const RegionsStores: RegionStoreMapping[] = [
    {
        region_id: 619,
        region_name: 'Hà Nội',
        store_code: 'hn_gen_two',
        scope: 'Miền Bắc',
        sort_order: 62,
        region_code: 'VN-63',
    },
    {
        region_id: 667,
        region_name: 'T.P. Hồ Chí Minh',
        store_code: 'hcm_gen_two',
        scope: 'Miền Nam',
        sort_order: 61,
        region_code: 'VN-62',
    },
    {
        region_id: 669,
        region_name: 'Bắc Ninh',
        store_code: 'hn_gen_two',
        scope: 'Miền Bắc',
        sort_order: 60,
        region_code: 'VN-06',
    },
    {
        region_id: 638,
        region_name: 'Hải Phòng',
        store_code: 'hn_gen_two',
        scope: 'Miền Bắc',
        sort_order: 59,
        region_code: 'VN-60',
    },
    {
        region_id: 632,
        region_name: 'Nam Định',
        store_code: 'hn_gen_two',
        scope: 'Miền Bắc',
        sort_order: 58,
        region_code: 'VN-35',
    },
    {
        region_id: 609,
        region_name: 'An Giang',
        store_code: 'hcm_gen_two',
        scope: 'Miền Nam',
        sort_order: 57,
        region_code: 'VN-01',
    },
    {
        region_id: 643,
        region_name: 'Bà Rịa - Vũng Tàu',
        store_code: 'hcm_gen_two',
        scope: 'Miền Nam',
        sort_order: 56,
        region_code: 'VN-02',
    },
    {
        region_id: 670,
        region_name: 'Bắc Giang',
        store_code: 'hn_gen_two',
        scope: 'Miền Bắc',
        sort_order: 55,
        region_code: 'VN-03',
    },
    {
        region_id: 671,
        region_name: 'Bắc Kạn',
        store_code: 'hn_gen_two',
        scope: 'Miền Bắc',
        sort_order: 54,
        region_code: 'VN-04',
    },
    {
        region_id: 656,
        region_name: 'Bạc Liêu',
        store_code: 'hcm_gen_two',
        scope: 'Miền Nam',
        sort_order: 53,
        region_code: 'VN-05',
    },
    {
        region_id: 634,
        region_name: 'Bến Tre',
        store_code: 'hcm_gen_two',
        scope: 'Miền Nam',
        sort_order: 52,
        region_code: 'VN-07',
    },
    {
        region_id: 645,
        region_name: 'Bình Dương',
        store_code: 'hcm_gen_two',
        scope: 'Miền Nam',
        sort_order: 51,
        region_code: 'VN-09',
    },
    {
        region_id: 613,
        region_name: 'Bình Phước',
        store_code: 'hcm_gen_two',
        scope: 'Miền Nam',
        sort_order: 50,
        region_code: 'VN-10',
    },
    {
        region_id: 636,
        region_name: 'Bình Thuận',
        store_code: 'hcm_gen_two',
        scope: 'Miền Nam',
        sort_order: 49,
        region_code: 'VN-11',
    },
    {
        region_id: 623,
        region_name: 'Bình Định',
        store_code: 'hcm_gen_two',
        scope: 'Miền Nam',
        sort_order: 48,
        region_code: 'VN-08',
    },
    {
        region_id: 644,
        region_name: 'Cà Mau',
        store_code: 'hcm_gen_two',
        scope: 'Miền Nam',
        sort_order: 47,
        region_code: 'VN-12',
    },
    {
        region_id: 646,
        region_name: 'Cần Thơ',
        store_code: 'hcm_gen_two',
        scope: 'Miền Nam',
        sort_order: 46,
        region_code: 'VN-59',
    },
    {
        region_id: 637,
        region_name: 'Cao Bằng',
        store_code: 'hn_gen_two',
        scope: 'Miền Bắc',
        sort_order: 45,
        region_code: 'VN-13',
    },
    {
        region_id: 629,
        region_name: 'Đà Nẵng',
        store_code: 'hn_gen_two',
        scope: 'Miền Bắc',
        sort_order: 44,
        region_code: 'VN-61',
    },
    {
        region_id: 653,
        region_name: 'Đắk Lắk',
        store_code: 'hcm_gen_two',
        scope: 'Miền Nam',
        sort_order: 43,
        region_code: 'VN-14',
    },
    {
        region_id: 611,
        region_name: 'Đắk Nông',
        store_code: 'hcm_gen_two',
        scope: 'Miền Nam',
        sort_order: 42,
        region_code: 'VN-15',
    },
    {
        region_id: 650,
        region_name: 'Điện Biên',
        store_code: 'hn_gen_two',
        scope: 'Miền Bắc',
        sort_order: 41,
        region_code: 'VN-16',
    },
    {
        region_id: 648,
        region_name: 'Đồng Nai',
        store_code: 'hcm_gen_two',
        scope: 'Miền Nam',
        sort_order: 40,
        region_code: 'VN-17',
    },
    {
        region_id: 661,
        region_name: 'Đồng Tháp',
        store_code: 'hcm_gen_two',
        scope: 'Miền Nam',
        sort_order: 39,
        region_code: 'VN-18',
    },
    {
        region_id: 641,
        region_name: 'Gia Lai',
        store_code: 'hcm_gen_two',
        scope: 'Miền Nam',
        sort_order: 0,
        region_code: 'VN-19',
    },
    {
        region_id: 626,
        region_name: 'Hà Giang',
        store_code: 'hn_gen_two',
        scope: 'Miền Bắc',
        sort_order: 0,
        region_code: 'VN-20',
    },
    {
        region_id: 668,
        region_name: 'Hà Nam',
        store_code: 'hn_gen_two',
        scope: 'Miền Bắc',
        sort_order: 0,
        region_code: 'VN-21',
    },
    {
        region_id: 659,
        region_name: 'Hà Tĩnh',
        store_code: 'hn_gen_two',
        scope: 'Miền Bắc',
        sort_order: 0,
        region_code: 'VN-22',
    },
    {
        region_id: 655,
        region_name: 'Hải Dương',
        store_code: 'hn_gen_two',
        scope: 'Miền Bắc',
        sort_order: 0,
        region_code: 'VN-23',
    },
    {
        region_id: 663,
        region_name: 'Hậu Giang',
        store_code: 'hcm_gen_two',
        scope: 'Miền Nam',
        sort_order: 0,
        region_code: 'VN-24',
    },
    {
        region_id: 642,
        region_name: 'Hòa Bình',
        store_code: 'hn_gen_two',
        scope: 'Miền Bắc',
        sort_order: 0,
        region_code: 'VN-25',
    },
    {
        region_id: 614,
        region_name: 'Hưng Yên',
        store_code: 'hn_gen_two',
        scope: 'Miền Bắc',
        sort_order: 0,
        region_code: 'VN-26',
    },
    {
        region_id: 635,
        region_name: 'Khánh Hòa',
        store_code: 'hcm_gen_two',
        scope: 'Miền Nam',
        sort_order: 0,
        region_code: 'VN-27',
    },
    {
        region_id: 625,
        region_name: 'Kiên Giang',
        store_code: 'hcm_gen_two',
        scope: 'Miền Nam',
        sort_order: 0,
        region_code: 'VN-28',
    },
    {
        region_id: 610,
        region_name: 'Kon Tum',
        store_code: 'hcm_gen_two',
        scope: 'Miền Nam',
        sort_order: 0,
        region_code: 'VN-29',
    },
    {
        region_id: 633,
        region_name: 'Lai Châu',
        store_code: 'hn_gen_two',
        scope: 'Miền Bắc',
        sort_order: 0,
        region_code: 'VN-30',
    },
    {
        region_id: 622,
        region_name: 'Lâm Đồng',
        store_code: 'hcm_gen_two',
        scope: 'Miền Nam',
        sort_order: 0,
        region_code: 'VN-31',
    },
    {
        region_id: 628,
        region_name: 'Lạng Sơn',
        store_code: 'hn_gen_two',
        scope: 'Miền Bắc',
        sort_order: 0,
        region_code: 'VN-32',
    },
    {
        region_id: 620,
        region_name: 'Lào Cai',
        store_code: 'hn_gen_two',
        scope: 'Miền Bắc',
        sort_order: 0,
        region_code: 'VN-33',
    },
    {
        region_id: 662,
        region_name: 'Long An',
        store_code: 'hcm_gen_two',
        scope: 'Miền Nam',
        sort_order: 0,
        region_code: 'VN-34',
    },
    {
        region_id: 624,
        region_name: 'Nghệ An',
        store_code: 'hn_gen_two',
        scope: 'Miền Bắc',
        sort_order: 0,
        region_code: 'VN-36',
    },
    {
        region_id: 639,
        region_name: 'Ninh Bình',
        store_code: 'hn_gen_two',
        scope: 'Miền Bắc',
        sort_order: 0,
        region_code: 'VN-37',
    },
    {
        region_id: 660,
        region_name: 'Ninh Thuận',
        store_code: 'hcm_gen_two',
        scope: 'Miền Nam',
        sort_order: 0,
        region_code: 'VN-38',
    },
    {
        region_id: 665,
        region_name: 'Phú Thọ',
        store_code: 'hn_gen_two',
        scope: 'Miền Bắc',
        sort_order: 0,
        region_code: 'VN-39',
    },
    {
        region_id: 627,
        region_name: 'Phú Yên',
        store_code: 'hcm_gen_two',
        scope: 'Miền Nam',
        sort_order: 0,
        region_code: 'VN-58',
    },
    {
        region_id: 666,
        region_name: 'Quảng Bình',
        store_code: 'hn_gen_two',
        scope: 'Miền Bắc',
        sort_order: 0,
        region_code: 'VN-40',
    },
    {
        region_id: 652,
        region_name: 'Quảng Nam',
        store_code: 'hcm_gen_two',
        scope: 'Miền Nam',
        sort_order: 0,
        region_code: 'VN-41',
    },
    {
        region_id: 618,
        region_name: 'Quảng Ngãi',
        store_code: 'hcm_gen_two',
        scope: 'Miền Nam',
        sort_order: 0,
        region_code: 'VN-42',
    },
    {
        region_id: 664,
        region_name: 'Quảng Ninh',
        store_code: 'hn_gen_two',
        scope: 'Miền Bắc',
        sort_order: 0,
        region_code: 'VN-43',
    },
    {
        region_id: 616,
        region_name: 'Quảng Trị',
        store_code: 'hn_gen_two',
        scope: 'Miền Bắc',
        sort_order: 0,
        region_code: 'VN-44',
    },
    {
        region_id: 612,
        region_name: 'Sóc Trăng',
        store_code: 'hcm_gen_two',
        scope: 'Miền Nam',
        sort_order: 0,
        region_code: 'VN-45',
    },
    {
        region_id: 630,
        region_name: 'Sơn La',
        store_code: 'hn_gen_two',
        scope: 'Miền Bắc',
        sort_order: 0,
        region_code: 'VN-46',
    },
    {
        region_id: 631,
        region_name: 'Tây Ninh',
        store_code: 'hcm_gen_two',
        scope: 'Miền Nam',
        sort_order: 0,
        region_code: 'VN-47',
    },
    {
        region_id: 658,
        region_name: 'Thái Bình',
        store_code: 'hn_gen_two',
        scope: 'Miền Bắc',
        sort_order: 0,
        region_code: 'VN-48',
    },
    {
        region_id: 654,
        region_name: 'Thái Nguyên',
        store_code: 'hn_gen_two',
        scope: 'Miền Bắc',
        sort_order: 0,
        region_code: 'VN-49',
    },
    {
        region_id: 615,
        region_name: 'Thanh Hóa',
        store_code: 'hn_gen_two',
        scope: 'Miền Bắc',
        sort_order: 0,
        region_code: 'VN-50',
    },
    {
        region_id: 647,
        region_name: 'Thừa Thiên Huế',
        store_code: 'hn_gen_two',
        scope: 'Miền Bắc',
        sort_order: 0,
        region_code: 'VN-51',
    },
    {
        region_id: 649,
        region_name: 'Tiền Giang',
        store_code: 'hcm_gen_two',
        scope: 'Miền Nam',
        sort_order: 0,
        region_code: 'VN-52',
    },
    {
        region_id: 657,
        region_name: 'Trà Vinh',
        store_code: 'hcm_gen_two',
        scope: 'Miền Nam',
        sort_order: 0,
        region_code: 'VN-53',
    },
    {
        region_id: 617,
        region_name: 'Tuyên Quang',
        store_code: 'hn_gen_two',
        scope: 'Miền Bắc',
        sort_order: 0,
        region_code: 'VN-54',
    },
    {
        region_id: 621,
        region_name: 'Vĩnh Long',
        store_code: 'hcm_gen_two',
        scope: 'Miền Nam',
        sort_order: 0,
        region_code: 'VN-55',
    },
    {
        region_id: 651,
        region_name: 'Vĩnh Phúc',
        store_code: 'hn_gen_two',
        scope: 'Miền Bắc',
        sort_order: 0,
        region_code: 'VN-56',
    },
    {
        region_id: 640,
        region_name: 'Yên Bái',
        store_code: 'hn_gen_two',
        scope: 'Miền Bắc',
        sort_order: 0,
        region_code: 'VN-57',
    },
];

export const defaultNorthSideRegion = {
    value: 'VN-63',
    label: 'Hà Nội',
    priority: 1,
    id: 619,
    code: 'VN-63',
};

export const defaultSouthSideRegion = {
    value: 'VN-62',
    label: 'T.P. Hồ Chí Minh',
    priority: 2,
    id: 667,
    code: 'VN-62',
};
